import React, { useState, useEffect } from "react";
import soundtest from "../../../img/soundtest.svg";
import loader from "../../../img/loder.gif";
import anime from "animejs";
import NavHear from "./NavHear";
import Footer from "./TestFooter/Footer";
import { Link } from "react-router-dom";
import BackImg from "../../../img/back.svg";
import "./heartest.css";
import { useDispatch } from "react-redux";
import { testQuestion } from "../../../Helper/Redux/API";
function Measuretest() {
  const [noiseLevel, setNoiseLevel] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    localStorage.getItem("Measuretest")
  );
  const [isMeasuring, setIsMeasuring] = useState(false);
  const [onhide, setOnShow] = useState(false);
  const [isNoiseMeasurementOngoing, setIsNoiseMeasurementOngoing] =
    useState(false);

  let audioContext;
  let analyser;
  let microphone;
  let timeoutId;

  const updateNoiseLevel = () => {
    // if (isMeasuring) {
    const dataArray = new Uint8Array(analyser.frequencyBinCount);
    analyser.getByteFrequencyData(dataArray);
    const average =
      dataArray.reduce((acc, value) => acc + value, 0) / dataArray.length;
    setNoiseLevel(average);
    timeoutId = setTimeout(updateNoiseLevel, 1000);
    // }
  };

  const startNoiseMeasurement = async () => {
    setOnShow(true);
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
    analyser = audioContext.createAnalyser();

    try {
      microphone = await navigator.mediaDevices.getUserMedia({ audio: true });
      const microphoneSource = audioContext.createMediaStreamSource(microphone);
      microphoneSource.connect(analyser);

      // Set up the analyzer
      analyser.fftSize = 256;

      // Start measuring noise level
      setIsMeasuring(true);
      updateNoiseLevel();
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  };

  const stopNoiseMeasurement = () => {
    setIsMeasuring(false);
    setOnShow(false);
    setNoiseLevel(0);
    if (microphone) {
      microphone.getTracks().forEach((track) => track.stop());
    }
    // if (audioContext) {
    //   audioContext.close();
    // }
    // Clear the timeout when stopping measurement
    clearTimeout(timeoutId);
  };

  useEffect(() => {
    // Clean up when component unmounts
    return () => {
      stopNoiseMeasurement();
    };
  }, []);

  const animateCircles = (color1, color2) => {
    const circles = document.querySelectorAll(".circle");
    anime({
      targets: circles,
      fill: [color1, color2], // Toggle between two colors
      easing: "linear", // Use a linear easing function for smooth transitions
      duration: 500, // Adjust duration as needed
    });
  };

  useEffect(() => {
    const color1 = getColorForNoiseLevel(noiseLevel);
    const color2 = "#47A67A"; // Adjust the second color as needed
    animateCircles(color1, color2);
  }, [noiseLevel]);

  const getColorForNoiseLevel = (level) => {
    if (level < 10) {
      return "#fff"; // Green for low noise
    } else if (level < 100) {
      return "#47A67A"; // Yellow for medium noise
    } else {
      return "#47A67A"; // Red for high noise
    }
  };

  const handleRadioChange = async (e) => {
    setSelectedOption(e.target.value);

    // Start or stop measuring based on the selected radio button
    if (
      e.target.value === "Very Soft" ||
      e.target.value === "Soft" ||
      e.target.value === "Moderate" ||
      e.target.value === "Loud"
    ) {
      await startNoiseMeasurement();
      // console.log("ddsdsd", noiseLevel);
      setIsNoiseMeasurementOngoing(true);
      setIsButtonDisabled(false);
      setTimeout(() => {
        stopNoiseMeasurement();
        setIsNoiseMeasurementOngoing(false);
        localStorage.setItem("Measuretest", e.target.value);
        setIsButtonDisabled(true);
      }, 10000);
    } else {
      stopNoiseMeasurement();
      setIsNoiseMeasurementOngoing(false);
    }
  };

  const handleRestart = () => {
    if (selectedOption) {
      startNoiseMeasurement();
      setIsNoiseMeasurementOngoing(true);
      setIsButtonDisabled(false);
      setTimeout(() => {
        stopNoiseMeasurement();
        setIsNoiseMeasurementOngoing(false);
        setIsButtonDisabled(true);
      }, 10000);
    } else {
      stopNoiseMeasurement();
      setIsNoiseMeasurementOngoing(false);
    }
  };
  const [question, setQuestion] = useState("");
  const [answerOption, serAnswerOption] = useState([]);

  const dispatch = useDispatch();

  const getQuestion = () => {
    const data = {
      page_number: 9,
    };
    try {
      dispatch(testQuestion(data)).then((res) => {
        if (res?.payload?.status === true) {
          setQuestion(res?.payload?.data[0]?.title);
          serAnswerOption(res?.payload?.data[0]?.options);
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getQuestion();
  }, []);
  return (
    <>
      <div className="test-from">
        <NavHear />{" "}
        <section className="step_form">
          <div className="container">
            {/* container start */}
            <section className="step_1 step2">
              <div className="Back_div">
                <Link to="/hearingtest/setup-instructions">
                  <img src={BackImg} alt="back" className="img-fluid" />
                </Link>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="step1_img">
                    <div className="quiet_place">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="295"
                        height="42"
                        viewBox="0 0 295 42"
                        fill="none"
                      >
                        {/* Add a class 'circle' to each circle element */}
                        <circle cx="9.5" cy="9.5" r="9.5" className="circle" />
                        <circle cx="9.5" cy="9.5" r="9.5" className="circle" />
                        <circle cx="9.5" cy="32.5" r="9.5" className="circle" />
                        <circle cx="32.5" cy="9.5" r="9.5" className="circle" />
                        <circle
                          cx="32.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle cx="55.5" cy="9.5" r="9.5" className="circle" />
                        <circle
                          cx="55.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle cx="78.5" cy="9.5" r="9.5" className="circle" />
                        <circle
                          cx="78.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="101.5"
                          cy="9.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="101.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="124.5"
                          cy="9.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="124.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="147.5"
                          cy="9.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="147.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="170.5"
                          cy="9.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="170.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="193.5"
                          cy="9.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="193.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="216.5"
                          cy="9.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle
                          cx="216.5"
                          cy="32.5"
                          r="9.5"
                          className="circle"
                        />
                        <circle cx="239.5" cy="9.5" r="9.5" fill="#d9d9d9" />
                        <circle cx="239.5" cy="32.5" r="9.5" fill="#d9d9d9" />
                        <circle cx="262.5" cy="9.5" r="9.5" fill="#d9d9d9" />
                        <circle cx="262.5" cy="32.5" r="9.5" fill="#d9d9d9" />
                        <circle cx="285.5" cy="9.5" r="9.5" fill="#d9d9d9" />
                        <circle cx="285.5" cy="32.5" r="9.5" fill="#d9d9d9" />
                        {/* Repeat for other circle elements */}
                        {/* ... */}
                      </svg>

                      {onhide ? (
                        <div className="quiet_test">
                          <h6>Measureing...</h6>
                          <p> Please stay silent</p>
                          <img
                            src={loader}
                            alt="loder"
                            className="img-fluid loader_img"
                          />
                        </div>
                      ) : (
                        <div className="quiet_test">
                          <h6>Perfect!</h6>
                          <p>
                            {" "}
                            The place is quiet enough to proceed with the tone
                            test
                          </p>
                          <button onClick={handleRestart} className="btn">
                            Measure again
                          </button>
                        </div>
                      )}

                      {isButtonDisabled ? (
                        <Link to="/hearingtest/measurement/right-500">
                          <button className="btn next_measure">Next</button>
                        </Link>
                      ) : (
                        <button disabled className="btn next_measure">
                          Next
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="step1_text ">
                    <h1>Find a quiet place</h1>
                    <p className="new_space">
                      The hearing test will be more accurate when it is done
                      without any disturbing background noise
                    </p>
                    <div className="step2_seletct">
                      <h5>{question}</h5>

                      <ul className="list_item">
                        {answerOption?.map((option, i) => (
                          <li key={i}>
                            <div
                              className={`form-check form-check-inline ${
                                selectedOption == option?.title ? "checked" : ""
                              }`}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="inlineRadioOptions"
                                id="inlineRadio1"
                                value={option?.title}
                                checked={selectedOption == option?.title}
                                onChange={handleRadioChange}
                                disabled={isNoiseMeasurementOngoing}
                              />
                              <span className="raound_text"></span>
                              <label
                                className="form-check-label"
                                for="inlineRadio1"
                              >
                                {option?.title}
                              </label>
                            </div>
                          </li>
                        ))}
                        {/* <li>
                          <div
                            className={`form-check form-check-inline ${
                              selectedOption === "Very Soft" ? "checked" : ""
                            }`}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio1"
                              value="Very Soft"
                              checked={selectedOption === "Very Soft"}
                              onChange={handleRadioChange}
                              disabled={isNoiseMeasurementOngoing}
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio1"
                            >
                              Very Soft
                            </label>
                          </div>
                        </li>
                        <li>
                          <div
                            className={`form-check form-check-inline ${
                              selectedOption === "Soft" ? "checked" : ""
                            }`}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio2"
                              value="Soft"
                              checked={selectedOption === "Soft"}
                              onChange={handleRadioChange}
                              disabled={isNoiseMeasurementOngoing}
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio2"
                            >
                              Soft
                            </label>
                          </div>
                        </li>

                        <li>
                          <div
                            className={`form-check form-check-inline ${
                              selectedOption === "Moderate" ? "checked" : ""
                            }`}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio3"
                              value="Moderate"
                              checked={selectedOption === "Moderate"}
                              onChange={handleRadioChange}
                              disabled={isNoiseMeasurementOngoing}
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio3"
                            >
                              Moderate
                            </label>
                          </div>
                        </li>

                        <li>
                          <div
                            className={`form-check form-check-inline ${
                              selectedOption === "Loud" ? "checked" : ""
                            }`}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio8"
                              value="Loud"
                              checked={selectedOption === "Loud"}
                              onChange={handleRadioChange}
                              disabled={isNoiseMeasurementOngoing}
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio8"
                            >
                              Loud
                            </label>
                          </div>
                        </li> */}
                      </ul>

                      {/* <button className="btn" onClick={onNext}>
                  Step 3
                </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* container end */}
          </div>
          {/* <p>Noise Level: {noiseLevel}</p> */}
          {/* <Link to="/hearingtest/measurement/right-2000">
            {" "}
            <button className="btn">Let’s Start!</button>
          </Link> */}
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Measuretest;
